export const P404 = () => {
    return (
        <div>404</div>
    )
}
